<div class="modal-header">
    <div class="modal-title">Prepared For</div>
    <button type="button" class="close" id="prepared-modal-close" aria-label="Close" (click)="decline()">
        <span aria-hidden="true"></span>
    </button>
</div>

<div class="modal-body">
    <div class="row text-center font-italic">
        <p class="col-md-12 font-size-20">
            <ng-container *ngIf="userService.isOrganizationUser()">
                Currently the Report for <strong class="break-text">{{businessName}}</strong> has been prepared for <strong class="break-text">{{userService.getOrganizationName()}}</strong>.
            </ng-container>
            <ng-container *ngIf="!userService.isOrganizationUser()">
                Currently the Report for <strong class="break-text">{{businessName}}</strong> has been prepared for <strong class="break-text">{{userService.getUserCompanyName() ? userService.getUserCompanyName() : businessName}}</strong>.
            </ng-container>
        </p>

    </div>

    <form #preparedForForm="ngForm" novalidate="novalidate" autocomplete="off">
        <div class="row">
            <div class="col-md-12">
                <div class="label">Change the Intended User to:</div>
                <div class="color-secondary-gray font-size-14 font-weight-normal"><strong>Note:</strong> This change will also be reflected in the Report</div>
                <input type="text" class="input input__large input__blue" [(ngModel)]="formObj.PREPARED_FOR_ENTITY"
                    placeholder="New Intended User" #PREPARED_FOR_ENTITY="ngModel" required
                    name="PREPARED_FOR_ENTITY">
            </div>
            <div class="col-md-12 mt-3">
                <div class="label">New Intended User Address:</div>
                <div class="color-secondary-gray font-size-14 font-weight-normal"><strong>Note:</strong> Format as Street Address, City, State ZIP Code</div>
                <input type="text" class="input input__large input__blue" [(ngModel)]="formObj.PREPARED_FOR_ENTITY_ADDRESS"
                    placeholder="New Intended User Address" #PREPARED_FOR_ENTITY_ADDRESS="ngModel" required
                    name="PREPARED_FOR_ENTITY_ADDRESS">
            </div>
        </div>
    </form>

</div>

<div class="modal-footer">
    <button type="button" id="prepared-modal-cancel" class="button secondary__button large__button"
        (click)="decline()">Cancel</button>
    <button type="button" id="prepared-modal-continue" class="button primary__button large__button"
        (click)="callUpdateGroupAPI()" [disabled]="!preparedForForm.valid">Accept</button>
</div>
